import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./hooks/useAuth";
import WhatsAppButton from "./components/feature/WhatsAppButton";
import PageLoader from "./components/base/PageLoader";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <Suspense fallback={<PageLoader />}>
            <AppRoutes />
          </Suspense>
          <WhatsAppButton />
        </BrowserRouter>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;